import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Label,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ListGroup,
  FormGroup,
  Badge
} from 'reactstrap';
import Loader from '../../../commons/loader';
import TermekcsoportItem from './TermekcsoportItem';
import TermekItem from './TermekItem';
import KosarItem from './KosarItem';
import Services from '../services';
import DataEmptyState from '../../../commons/dataemptystate';
import NetworkEmptyState from '../../../commons/networkemptystate';
import { ProgressButton } from '../../../commons/ProgressButton';
import SwitchButton from '../../../commons/SwitchButton';

const CONSTANTS = {
  fizetesiModAzonositok: [
    { azon: 'PPOS', icon: 'fa-credit-card' },
    { azon: 'KP', icon: 'fa-money' },
  ]
};

class BufeContent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // ['LOAD', 'DATA', 'NETW', 'TABL']
      termekCsoportStatus: 'LOAD',
      // ['LOAD', 'DATA', 'NETW', 'TABL']
      termekStatus: 'LOAD',
      /** @type {boolean} */
      modalFizetes: false,
      /** @type {boolean} */
      fizetesLoading: false,
      formBufe: '',
      formTermekCsoport: '',
      formTermekCsoportNev: '',
      bufeOptions: [],
      termekCsoportok: [],
      termekek: [],
      kosar: [],
      dolgozoi: true,
      checkSiker: false,
      dolgozo: null,
      dolgozok: [],
      defaultCurrency: null,
      fizModOptions: [],
      fizModButtons: '',
      formFizModId: null,
      helybenFogyasztott: true,
      kedvezmenyKategoriak: [],
      penznemek: [],
      arfolyamok: [],
      formFizModKod: null,
      formPenznemId: null,
      penznemKod: null,
      arfolyam: 1
    };
  }

  componentDidMount() {
    this.getBufeList();
    this.getDefaultCurrency();
  }

  getDolgozoFromKeycloak = () => {
    let result = '';
    if (this.props && this.props.globals && this.props.globals.keycloak && this.props.globals.keycloak.tokenParsed && this.props.globals.keycloak.tokenParsed.sub) {
      result = this.props.globals.keycloak.tokenParsed.sub;
    }
    return result;
  }

  toggleFizetes = () => {
    if (!this.state.modalFizetes) {
      this.fizetes(true);
    } else {
      this.setState({ modalFizetes: false });
    }

    this.setState({
      dolgozo: '',
      kedvezmenyek: '',
      currentKedvezmeny: null,
      dolgozoi: true
    }
    // , () => {
    //   Services.listDolgozoiKedvezmenyek(this.state.formBufe, (err, res) => {
    //     if (!err) {
    //       this.setState({ dolgozoiKedvezmenyek: JSON.parse(JSON.stringify(res[0]))});
    //     }
    //   });
    // }
    );
  }

  toggleDolgozoiKedvezmeny = () => {
    this.setState(prevState => ({ 
      dolgozoi: !prevState.dolgozoi,
      dolgozo: '',
      kedvezmenyek: '',
      currentKedvezmeny: null
    }), () => {
      if (!this.state.dolgozoi) {
        this.getDolgozok(this.state.formBufe);
      }
    });
  }

  // getDolgozoKedvezmenyByDolgozoId = (dolgozoId) => {
  //   let kedvezmenyek = [];
  //   let dolgozok = JSON.parse(JSON.stringify(this.state.dolgozok));
  //   dolgozok.forEach((dolgozo) => {
  //     if (dolgozo.id === dolgozoId) {
  //       kedvezmenyek = dolgozo.szemelyKedvezmenyBeans;
  //     }
  //   });
  //   return kedvezmenyek;
  // }

  checkFizetes = () => {
    if (this.state.checkSiker) {
      this.setState(prevState => ({ modalFizetes: !prevState.modalFizetes }));
    }
  }

  onDolgozoChange = (e) => {
    const dolgozoID = e.target.value;
    this.setState({ dolgozo: dolgozoID }, () => {
      let kedvezmenyek = [];
      this.state.dolgozok.forEach((dolgozo) => {
        if (dolgozo.id === parseInt(dolgozoID, 10)) {
          dolgozo.szemelyKedvezmenyBeans.forEach((kedvezmeny) => {
            kedvezmenyek.push(
              kedvezmeny.id
            );
          });
        }
      });
      let kedvezmenyObj = null;
      if (kedvezmenyek.length === 1) {
        kedvezmenyObj = this.getKedvezmenyById(kedvezmenyek[0]);
      }
      this.setState({ kedvezmenyek: kedvezmenyek.length === 1 ? kedvezmenyek[0] : '', currentKedvezmeny: kedvezmenyObj });
    });
  }

  onKedvezmenyChange = (e) => {
    let kedvezmenyObj = this.getKedvezmenyById(e.target.value);
    this.setState({ kedvezmenyek: e.target.value, currentKedvezmeny: kedvezmenyObj });
  }


  getTermekCsoportData = (id) => {
    this.setState({
      termekCsoportStatus: 'LOAD',
    });
    Promise.all([
      this.getTermekCsoportList(id),
    ])
      .then(() => {
        this.setState(prevState => ({ termekCsoportStatus: prevState.termekCsoportok.length > 0 ? 'TABL' : 'DATA' }));
      })
      .catch(() => {
        this.setState({
          termekCsoportStatus: 'NETW'
        });
      });
  }

  getTermekData = (id) => {
    this.setState({
      termekStatus: 'LOAD',
    });
    Promise.all([
      window.scrollTo(0, 0),
      this.getTermekListErtekesites(id),
    ])
      .then(() => {
        this.setState(prevState => ({ termekStatus: prevState.termekek.length > 0 ? 'TABL' : 'DATA' }));
      })
      .catch(() => {
        this.setState({
          termekStatus: 'NETW'
        });
      });
  }

  getDefaultCurrency = () => {
    Services.getDefaultCurrency((err, res) => {
      if (!err) {
        this.setState({ defaultCurrency: res[0], formPenznemId: res[0] && res[0].id });
      } else {
        this.setState({ defaultCurrency: null, formPenznemId: null });
      }
    });
  }

  getBufeList = () => {
    Services.listBufekSelect((err, res) => {
      if (!err) {
        const optionsJson = res[0];
        let bufeOptions = optionsJson.map(e => <option key={e.id} value={e.id}>{e.nev + ' (' + e.kod + ')'}</option>);
        if (bufeOptions.length > 0) {
          this.handleInputChange({ target: { type: '', value: bufeOptions[0].key, name: 'formBufe' } });
        }
        this.setState({
          bufeOptions: bufeOptions,
        });

        if(!this.state.formBufe && optionsJson.length === 1) {
          this.setState({ formBufe: optionsJson[0].id });
          this.getTermekCsoportData(optionsJson[0].id);
        }
      }
    });
  }

  getTermekCsoportList = (id) => {
    return new Promise((resolve, reject) => {
      Services.listTermekCsoportErtekesites(id, (err, res) => {
        if (!err) {
          this.setState({
            termekCsoportok: res[0]
          }, () => {
            resolve();
          });
        } else {
          reject(new Error('Hálozati hiba!'));
        }
      });
    });
  }

  getTermekListErtekesites = (id) => {
    return new Promise((resolve, reject) => {
      Services.listTermekErtekesites(id, (err, res) => {
        if (!err) {
          this.setState({
            termekek: res[0]
          }, () => {
            resolve();
          });
        } else {
          reject(new Error('Hálozati hiba!'));
        }
      });
    });
  }

  handleInputChange = (e) => {
    const { target } = e;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
    this.setState({
      [name]: value,
      termekek: [],
      kosar: [],
      formFizModId: null,
      formPenznemId: null,
      formTermekCsoportNev: ''
    }, () => {
      if (value && value !== '') this.getTermekCsoportData(value);
    });
  }

  handleRadioChange = (e) => {
    const { target } = e;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
    this.setState({
      [name]: value,
    });
  }

  handlePlusClick = (item, idx) => {
    const { kosar } = this.state;
    let kosarCopy = [...kosar];

    kosarCopy[idx] = {
      id: item.id,
      termekid: item.termekid,
      listaar: item.listaar,
      nev: item.nev,
      mennyiseg: item.mennyiseg + 1,
    };

    this.setState({
      kosar: kosarCopy
    });
  }

  handleMinusClick = (item, idx) => {
    const { kosar } = this.state;
    let kosarCopy = [...kosar];

    if (item.mennyiseg <= 1) {
      let result = kosarCopy.filter(kosarItem => kosarItem.id !== item.id);
      this.setState({
        kosar: result,
      });
    } else {
      kosarCopy[idx] = {
        id: item.id,
        termekid: item.termekid,
        listaar: item.listaar,
        nev: item.nev,
        mennyiseg: item.mennyiseg - 1,
      };

      this.setState({
        kosar: kosarCopy
      });
    }
  }

  addTermekToKosar = (termek) => {
    const { kosar } = this.state;
    if (kosar.find(kosarItem => kosarItem.id === termek.id)) {
      let kosarCopy = [...kosar];

      let currentItem = kosarCopy.find(kosarItem => kosarItem.id === termek.id);
      let currentIndex = kosarCopy.findIndex(kosarItem => kosarItem.id === termek.id);
      kosarCopy[currentIndex] = {
        id: currentItem.id,
        termekid: termek.id,
        listaar: currentItem.listaar,
        nev: currentItem.nev,
        mennyiseg: currentItem.mennyiseg + 1,
        ntakalkategoria: termek.ntakalkategoria,
      };

      this.setState({
        kosar: kosarCopy
      });
    } else {
      let kosarCopy = [...kosar];

      kosarCopy.push({
        id: termek.id,
        termekid: termek.id,
        listaar: termek.listaar,
        nev: termek.rovidnev,
        mennyiseg: 1,
        ntakalkategoria: termek.ntakalkategoria,
      });

      this.setState({
        kosar: kosarCopy
      });
    }
  }

  fizetes = (check) => {
    const {
      formBufe,
      formFizModId,
      formPenznemId,
      kosar,
      dolgozo,
      kedvezmenyek,
      dolgozoi,
      helybenFogyasztott,
    } = this.state;
    let kosarCopy = [...kosar];
    if (!check) this.setState({ fizetesLoading: true });

    let forgalomtetelentities = [];
    let eladar = 0;
    kosarCopy.forEach((item) => {
      eladar += (item.listaar * item.mennyiseg);
      forgalomtetelentities.push({
        termekid: item.termekid,
        mennyiseg: item.mennyiseg,
        egysegar: item.listaar
      });
    });

    let forgalomObj = {
      bufeid: formBufe,
      szemelyid: dolgozoi ? '' : dolgozo,
      kedvezmenyid: dolgozoi ? '' : kedvezmenyek,
      eladar: this.getBucketPrice(),
      listaar: eladar,
      fizmodid: formFizModId,
      penznemid: formPenznemId,
      helybenfogyasztott: helybenFogyasztott ? 'true' : 'false',
      tetelek: forgalomtetelentities,
    };

    if (check == true) {
      let fizmod = [];
      CONSTANTS.fizetesiModAzonositok.forEach((object) => {
        fizmod.push(object.azon);
      });
      Services.getFizetesiModok(fizmod, (err, res) => {
        if (!err) {
          this.setState({ fizModOptions: res[0] });
        }
      });
      let checkObj = {};
      checkObj.bufeid = formBufe;
      checkObj.tetelek = forgalomtetelentities;
      Services.checkCikkekKeszleten(checkObj, (err) => {
        this.setState({ checkSiker: err === null }, () => {
          this.checkFizetes();
        });
      });
      Services.getKedvezmenyKategoriaToCalc((err, res) => {
        if (!err) {
          this.setState({ kedvezmenyKategoriak: res[0] });
        }
      });
      Services.getArfolyam((err, res) => {
        if (!err) {
          this.setState({ arfolyamok: res[0] });

          Services.getAktivPenznemek((err2, res2) => {
            if (!err2) {
              let p = [];
              if (this.state.arfolyamok) {
                res2[0].forEach((item) => {
                  let currentArfolyam = this.state.arfolyamok && this.state.arfolyamok.find(x => x[0] === item.azonosito);
                  let penznem = item;
                  penznem.arfolyam = currentArfolyam && currentArfolyam[1];
                  p.push(penznem);
                });

                this.setState({ penznemek: p });
              } else {
                this.setState({ penznemek: res2[0] });
              }
            }
          });
        }
      });
    } else if (!this.state.dolgozoi) {
      if ((this.state.dolgozo && this.state.dolgozo !== '') && (this.state.kedvezmenyek && this.state.kedvezmenyek !== '')) {
        if (this.getBucketPrice() < 0) {
          this.setState({ fizetesLoading: false });
          this.props.globals.addError('A rendelés végösszege nem lehet negatív!');
        } else {
        Services.insertForgalom(forgalomObj, (err) => {
          if (!err) {
            this.getTermekData(this.state.formTermekCsoport);
            this.setState({ fizetesLoading: false }, () => {
              this.toggleFizetes();
              this.setState({
                kosar: [],
                formFizModId: null,
                formPenznemId: null,
                  helybenFogyasztott: true,
                  penznemek: [],
                  arfolyamok: [],
                  formFizModKod: null,
                  penznemKod: null,
                  arfolyam: 1
              }, () => {
                this.props.globals.addSuccess("A vásárlás sikeres volt!");
              });
            });
          } else {
            this.setState({ fizetesLoading: false });
          }
        });
        }
      } else {
        this.setState({ fizetesLoading: false });
        this.props.globals.addWarning("Dolgozó és dolgozói kedvezmény megadása kötelező!")
      }
    } else if (this.getBucketPrice() < 0) {
      this.setState({ fizetesLoading: false });
      this.props.globals.addError('A rendelés végösszege nem lehet negatív!');
    } else {
      Services.insertForgalom(forgalomObj, (err) => {
        if (!err) {
          this.getTermekData(this.state.formTermekCsoport);
          this.setState({ fizetesLoading: false }, () => {
            this.toggleFizetes();
            this.setState({
              kosar: [],
              formFizModId: null,
              formPenznemId: null,
              helybenFogyasztott: true,
              penznemek: [],
              arfolyamok: [],
              formFizModKod: null,
              penznemKod: null,
              arfolyam: 1
            }, () => {
              this.props.globals.addSuccess("A vásárlás sikeres volt!");
            });
          });
        } else {
          this.setState({ fizetesLoading: false });
        }
      });
    }
  }

  filterTermekcsoportok = (oszlop) => {
    let { termekCsoportok } = this.state;
    if (oszlop !== null) { 
      termekCsoportok = termekCsoportok.filter(tcs => tcs.sorszam % 2 === oszlop); 
    }
    return termekCsoportok.map((item) => {
      return (
        <TermekcsoportItem
          onClick={
            () => {
              this.setState({ formTermekCsoport: item.id, formTermekCsoportNev: item.nev }, () => {
                this.getTermekData(item.id);
              });
            }}
          key={item.id}
          szinkod={item.szinkod}
        >
          {item.nev}
        </TermekcsoportItem>
      );
    });
  }

  renderTermekCsoportok = (oszlop) => {
    return (
      <React.Fragment>
        <ListGroup>
          {this.filterTermekcsoportok(oszlop)}
        </ListGroup>
      </React.Fragment>
    );
  }

  renderTermekek = () => {
    const {
      termekek
    } = this.state;

    return (
      <React.Fragment>
        {termekek.map((item) => {
          return (
            <TermekItem
              nev={item.rovidnev}
              ar={item.listaar}
              defaultCurrencyAzon={this.state.defaultCurrency && this.state.defaultCurrency.azonosito}
              szinkod={item.szinkod}
              onClick={() => {
                this.addTermekToKosar(item);
              }}
            />
          );
        })}
      </React.Fragment>
    );
  }

  renderKosar = () => {
    const {
      kosar
    } = this.state;

    return (
      <React.Fragment>
        {kosar.map((item, idx) => {
          return (
            <KosarItem
              mennyiseg={item.mennyiseg}
              termeknev={item.nev}
              egysegar={item.listaar}
              idx={item.id}
              onPlusClick={() => { this.handlePlusClick(item, idx); }}
              onMinusClick={() => { this.handleMinusClick(item, idx); }}
              defaultCurrencyAzon={this.state.defaultCurrency && this.state.defaultCurrency.azonosito}
            />
          );
        })}
      </React.Fragment>
    );
  }

  renderFizetes = () => {
    const {
      kosar
    } = this.state;

    return (
      <React.Fragment>
        {kosar.map((item) => {
          return (
            <div className="col-sm-8 col-md-8 col-lg-8" key={item.id}>
              <div>
                <b>{item.nev}</b>
                <p style={{ textAlign: 'left', marginBottom: 4 }}>
                {item.listaar + ' ' + (this.state.defaultCurrency && this.state.defaultCurrency.azonosito)}
                  <Badge color="secondary">{'x' + item.mennyiseg}</Badge>
                  <span style={{ float: 'right' }}>
                  {item.listaar * item.mennyiseg + ' ' + (this.state.defaultCurrency && this.state.defaultCurrency.azonosito)}
                  </span>
                </p>
              </div>
            </div>
          );
        })}
      </React.Fragment>
    );
  }

  // let resOptions = res[0].map(e => <option key={e.variansid ? e.variansid : e.id} value={e.variansid ? e.variansid : e.id}>{e.variansnev ? e.variansnev : e.nev}</option>);

  renderFizetesiMod = () => {
    const {
      fizModOptions,
    } = this.state;

    return (
      <React.Fragment>
        {fizModOptions.map((item) => {
          return (
            <Button
              type="button"
              size="lg"
              color={this.state.formFizModId === item.id ? 'warning' : 'secondary'}
              style={{ marginBottom: 10, marginRight: 10 }}
              onClick={() => {
                this.setState(prevState => ({
                  formFizModId: item.id,
                  formFizModKod: item.kod,
                  formPenznemId: item.kod === 'KP' ? prevState.formPenznemId : (prevState.defaultCurrency && prevState.defaultCurrency.id),
                  arfolyam: item.kod === 'KP' ? prevState.arfolyam : 1,
                  penznemKod: item.kod === 'KP' ? prevState.penznemKod : ''
                }));
              }}
            >
              <i className={'fa ' + CONSTANTS.fizetesiModAzonositok.find(x => item.kod === x.azon).icon} aria-hidden="true" />
              {' ' + item.nev}
            </Button>
          );
        })}
      </React.Fragment>
    );
  }

  renderPenznem = () => {
    const {
      penznemek,
    } = this.state;

    if (penznemek) {
      return (
        <React.Fragment>
          {/* <p style={{ fontSize: '1.65rem' }}>Fizetési mód megadása:</p> */}
          <div className="row">
            {this.renderPenznemTypeInputs(penznemek)}
          </div>
        </React.Fragment>
      );
    }

    return <p>Nincs választható fizetési mód!</p>;
  }

  renderPenznemTypeInputs = (penznemek) => {
    return penznemek.map((penznem) => {
      let formName = 'formPenznemId' + penznem.azonosito;
      if (!this.state.formPenznemId && this.state.defaultCurrency && this.state.defaultCurrency.azonosito === penznem.azonosito) {
        this.setState({ formPenznemId: penznem.id });
      }
      return (
        <div className="col-md-4" style={{ }}>
          <input
            name="formPenznemId"
            type="radio"
            id={formName}
            checked={parseInt(this.state.formPenznemId, 10) === penznem.id}
            onChange={(e) => {
              this.handleRadioChange(e);
              this.setState({ arfolyam: penznem.arfolyam ? penznem.arfolyam : 1, penznemKod: penznem.azonosito });
            }}
            value={penznem.id}
          />
          <label htmlFor={formName} style={{ display: 'inline-block', paddingLeft: '5px' }}>{penznem.azonosito}</label>
          <br />
        </div>
      );
    });
  }

  getDolgozok = (id) => {
    Services.listDolgozok(id, (err, res) => {
      if (!err) {
        this.setState({ dolgozok: res[0] === '' ? [] : res[0] }, () => {
          let dolgozok = JSON.parse(JSON.stringify(this.state.dolgozok));
          dolgozok.forEach((dolgozo) => {
            if (dolgozo.kulsoazonosito === this.getDolgozoFromKeycloak()) {

              this.setState({ dolgozo: dolgozo.id }, () => {
                let kedvezmenyObj = null;
                if (dolgozo.szemelyKedvezmenyBeans.length === 1) {
                  kedvezmenyObj = this.getKedvezmenyById(dolgozo.szemelyKedvezmenyBeans[0].id);
                }
                this.setState({ currentKedvezmeny: kedvezmenyObj, kedvezmenyek: kedvezmenyObj && kedvezmenyObj.id });
              });
            }
          });
        });
      }
    });
  }

  renderDolgozokOptions = () => {
    let dolgozok = [];
    if (this.state.dolgozok) {
      this.state.dolgozok.forEach((e) => {
        dolgozok.push(
          <option key={e.id} value={e.id}>{e.nev}</option>
        );
      });
    }
    return dolgozok;
  }

  getDefaultBucketPrice = () => {
    let bucketPrice = 0;
    this.state.kosar.forEach((kosarItem) => {
      bucketPrice += kosarItem.mennyiseg * kosarItem.listaar;
    });
    return bucketPrice;
  }

  getBucketPrice = () => {
    let bucketPrice = 0;
    let kedvezmenySum = 0;

    this.state.kosar.forEach((kosarItem) => {
      if (this.state.kedvezmenyKategoriak.includes(kosarItem.ntakalkategoria)) {
        kedvezmenySum += -Math.abs(kosarItem.mennyiseg * kosarItem.listaar);
      } else {
        bucketPrice += kosarItem.mennyiseg * kosarItem.listaar;
      }
    });

    return this.getCorrectPrice(bucketPrice, kedvezmenySum, this.state.currentKedvezmeny);
  }

  getBuckerPriceByRate = () => {
    if (this.state.arfolyam === 1) {
      return null;
    }

    return (
      <React.Fragment>
        <br />
        {'(' + (parseFloat(this.getBucketPrice(), 10) / parseFloat(this.state.arfolyam, 10)).toFixed(2) + (this.state.penznemKod ? (' ' + this.state.penznemKod) : '') + ')'}
      </React.Fragment>
    );
  }

  getBucketPriceWithoutDiscount = () => {
    let bucketPrice = 0;
    this.state.kosar.forEach((kosarItem) => {
      bucketPrice += kosarItem.mennyiseg * kosarItem.listaar;
    });
    return bucketPrice;
  }

  getCorrectPrice = (price, kedvezmenySum, kedvezmeny) => {
    let total = 0;
    if (kedvezmeny && kedvezmeny.ervenyes) {
      if (kedvezmeny.ertek) {
        total = (price - kedvezmeny.ertek) + kedvezmenySum;
      }
      if (kedvezmeny.szazalek) {
        total = (Math.round(price - (price * (kedvezmeny.szazalek / 100)))) + kedvezmenySum;
      }

      // kp fizmódnál ft pénznemnél kerekítés
      if (this.state.formFizModKod === 'KP' && this.state.defaultCurrency && this.state.defaultCurrency.azonosito === 'HUF') {
        total = Math.round(parseFloat(total, 10) / 5) * 5;
      }

      return total;
    }

    total = price + kedvezmenySum;

    // kp fizmódnál ft pénznemnél kerekítés
    if (this.state.formFizModKod === 'KP' && this.state.defaultCurrency && this.state.defaultCurrency.azonosito === 'HUF') {
      total = Math.round(parseFloat(total, 10) / 5) * 5;
    }

    return total;
  }

  getKedvezmenyById = (id) => {
    let kedvezmenyObj = null;
    this.state.dolgozok.forEach((dolgozo) => {
      if (dolgozo.id === parseInt(this.state.dolgozo, 10)) {
        dolgozo.szemelyKedvezmenyBeans.forEach((kedvezmeny) => {
          if (kedvezmeny.id === parseInt(id, 10)) {
            kedvezmenyObj = kedvezmeny;
          }
        });
      }
    });
    return kedvezmenyObj;
  }

  renderDolgozokKedvezmenyeiOptions = () => {
    let kedvezmenyek = [];
    this.state.dolgozok.forEach((dolgozo) => {
      if (dolgozo.id === parseInt(this.state.dolgozo, 10)) {
        dolgozo.szemelyKedvezmenyBeans.forEach((kedvezmeny) => {
          kedvezmenyek.push(
            <option key={kedvezmeny.id} value={kedvezmeny.id}>{kedvezmeny.nev}</option>
          );
        });
      }
    });

    return kedvezmenyek;
  }

  render() {
    const {
      formBufe,
      formTermekCsoport,
      formTermekCsoportNev,
      bufeOptions,
      kosar,
      fizetesLoading
    } = this.state;


    return (
      <React.Fragment>
        <div className="row">
          <div className={(this.state.termekCsoportok.length > 5 ? "col-sm-4 col-md-4 col-lg-4":"col-sm-2 col-md-2 col-lg-2")}>
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-12" style={{ display: 'table' }}>
              <div style={{ width: '30px', paddingRight: '5px', display: 'table-cell' }}>
                Büfé:
              </div>
              <div style={{ paddingRight: '0px', width: '100%', display: 'table-cell' }}>
                <FormGroup>
                  <Input type="select" name="formBufe" id="formBufe" onChange={this.handleInputChange} disabled={bufeOptions.length <= 0} value={formBufe}>
                    <option value="">Válassz büfét...</option>
                    {bufeOptions}
                  </Input>
                </FormGroup>
              </div>
              </div>
          <div className={this.state.termekCsoportok.length > 5 ? "col-sm-6 col-md-6 col-lg-6":"col-sm-12 col-md-12 col-lg-12"} style={{ paddingRight: this.state.termekCsoportok.length > 5 ? '2px' : '', marginRight: '0px'}}>
            {formBufe && (
              {
                LOAD: (<Loader style={{ marginTop: 50 }} />),
                DATA: (<DataEmptyState
                  hasImage
                  title="Nincs aktív termékcsoport!"
                  subtitle="Vigyél fel új tételt!"
                />),
                NETW: (<NetworkEmptyState
                  hasImage
                  submitClick={() => this.getTermekCsoportData(this.state.formBufe)}
                />),
                TABL: (this.renderTermekCsoportok(this.state.termekCsoportok.length > 5 ? 1 : null))
              }[this.state.termekCsoportStatus]
            )}
          </div>
          {this.state.termekCsoportok.length > 5 ?
            <div className="col-sm-6 col-md-6 col-lg-6" style={{paddingLeft: '2px'}}>
              {formBufe && (
                {
                  TABL: (this.renderTermekCsoportok(0))
                }[this.state.termekCsoportStatus]
              )}
            </div>
             : <div />}
          </div>
          </div>
          <div className={this.state.termekCsoportok.length > 5 ? "col-sm-6 col-md-6 col-lg-6" : "col-sm-8 col-md-8 col-lg-8"}>
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-12">
                <h4 style={{ textAlign: 'center' }}>{formTermekCsoportNev}</h4>
              </div>
            </div>
            <div className="row">
              {formTermekCsoport && (
                {
                  LOAD: (<Loader style={{ marginTop: 50 }} />),
                  DATA: (<DataEmptyState
                    hasImage
                    title="A kiválasztott termékcsoporthoz nem létezik aktív termék!"
                    subtitle="Vigyél fel új tételt!"
                  />),
                  NETW: (<NetworkEmptyState
                    hasImage
                    submitClick={() => this.getTermekData(this.state.formTermekCsoport)}
                  />),
                  TABL: (this.renderTermekek())
                }[this.state.termekStatus]
              )}
            </div>
          </div>
          <div className="col-sm-2 col-md-2 col-lg-2">
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-12">
                <h4 style={{ textAlign: 'center' }}>Vásárlás</h4>
              </div>
              <div className="col-sm-12 col-md-12 col-lg-12" style={{ fontSize: 17, borderBottom: '2px solid gray', padding: '0px 5px 10px 5px', margin: '0px 0px 5px 0px' }}>
                <Button
                  color="success"
                  style={{ width: '100%' }}
                  disabled={kosar.length < 1}
                  size="lg"
                  onClick={() => {
                    if (this.getBucketPriceWithoutDiscount() < 0) {
                      this.props.globals.addError('A rendelés végösszege nem lehet negatív!');
                    } else {
                      this.toggleFizetes();
                    }
                  }}
                >
                  {this.getBucketPriceWithoutDiscount() + ' ' + (this.state.defaultCurrency && this.state.defaultCurrency.azonosito) + ' '}
                  <i className="fa fa-shopping-cart" aria-hidden="true" />
                </Button>
              </div>
              {this.renderKosar()}
            </div>
          </div>
        </div>
        <Modal isOpen={this.state.modalFizetes} toggle={this.toggleFizetes} backdrop="static" size="lg">
          <ModalHeader>
            <Button type="button" size="lg" color="primary" onClick={this.toggleFizetes}>
              <i className="fa fa-angle-left" aria-hidden="true" />
              {' Vissza'}
            </Button>
          </ModalHeader>
          <ModalBody>
            <div className="row">
              {/* egyelőre a pénznemválasztási lehetőség nem látható (csak NTAK fejlesztés miatt volt aktív), alapban a def.currency lesz átadva - mg */}
              {/* <div className="col-sm-6 col-md-6 col-lg-6">
                {this.renderFizetesiMod()}
              </div>
              <div className="col-sm-3 col-md-3 col-lg-3">
                {this.state.formFizModKod === 'KP' && this.renderPenznem()}
              </div> */}
              <div className="col-sm-6 col-md-6 col-lg-6">
                {this.renderFizetesiMod()}
              </div>
              {/* <div className="col-sm-3 col-md-3 col-lg-3">
                {this.state.formFizModKod === 'KP' && this.renderPenznem()}
              </div> */}
              <div className="col-sm-3 col-md-3 col-lg-3">
                <SwitchButton
                  active={this.state.helybenFogyasztott}
                  trueToggle={() => this.setState({ helybenFogyasztott: true })}
                  falseToggle={() => this.setState({ helybenFogyasztott: false })}
                  style={{ marginBottom: 15, marginTop: 8 }}
                  trueLabel="Helyben"
                  falseLabel="Elvitel"
                />
              </div>
              <div className="col-sm-3 col-md-3 col-lg-3">
                <ProgressButton
                  type="button"
                  size="lg"
                  loading={fizetesLoading}
                  color="success"
                  onClick={() => this.fizetes(false)}
                  className="float-right"
                  disabled={!this.state.formFizModId}
                  style={{ marginBottom: 10 }}
                >
                  {' Fizetés: '}
                  {this.getBucketPrice() + ' ' + (this.state.defaultCurrency && this.state.defaultCurrency.azonosito)}
                  {this.getBuckerPriceByRate()}
                </ProgressButton>
              </div>
            </div>
            <div className="row justify-content-md-center">
              <div className="col-sm-12 col-md-12 col-lg-12">
                <div
                  style={{
                    padding: 20,
                    margin: 6,
                    borderStyle: 'dashed',
                    borderColor: '#cfd8dc'
                  }}
                >
                  {this.renderFizetes()}
                  <div className="col-sm-12 col-md-12 col-lg-12" style={{ borderTop: '2px solid gray', fontSize: 17, paddingTop: 10 }}>
                    <div>
                      <p style={{ textAlign: 'left', marginBottom: 0 }}>
                        <b>
                          {'Eredeti ár: '}
                        </b>
                        <span style={{ float: 'right' }}>
                        {this.getDefaultBucketPrice() + ' ' + (this.state.defaultCurrency && this.state.defaultCurrency.azonosito)}
                        </span>
                      </p>
                    </div>
                    <div>
                      <p style={{ textAlign: 'left' }}>
                        <b>
                          {'Fizetendő: '}
                        </b>
                        <span style={{ float: 'right' }}>
                        {this.getBucketPrice() + ' ' + (this.state.defaultCurrency && this.state.defaultCurrency.azonosito)}
                        </span>
                      </p>
                    </div>
                    <div className="dolgozoi">
                      <Button color={this.state.dolgozoi ? 'secondary' : 'info'} onClick={this.toggleDolgozoiKedvezmeny}>
                        Dolgozói kedvezmény igénybevétele
                      </Button>
                      <br />
                      <br />
                      <div id="dolgozokedv" className="row" hidden={this.state.dolgozoi}>
                        <div className="col-md-6">
                          <Input
                            type="select"
                            name="dolgozo"
                            id="dolgozo"
                            onChange={this.onDolgozoChange}
                            value={this.state.dolgozo}
                          >
                            <option key="" value="">Kérjük válassz dolgozót...</option>
                            {this.renderDolgozokOptions()}
                          </Input>
                        </div>
                        <div className="col-md-6">
                          <Input
                            type="select"
                            name="dolgozokedvezmeny"
                            id="dolgozokedvezmeny"
                            value={this.state.kedvezmenyek}
                            onChange={this.onKedvezmenyChange}
                          >
                            <option value="">Kérjük válassz kedvezményt...</option>
                            {this.renderDolgozokKedvezmenyeiOptions()}
                          </Input>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </React.Fragment>
    );
  }
}

BufeContent.propTypes = {
  globals: PropTypes.object
};

export default BufeContent;
